<template>
  <div id="Draw" :class="{ home: home === true, drawHome : home === true}" >
    <div v-if="home === true">
      <b-container>
        <b-row class="homeLeader" :class="{homewidthTakover: takeover == true}">
          <b-col>
            <template v-if="web_sponsor !== ''">
              <b-img v-if="data.code != '1001'" class='courseLogo' :src='web_sponsor'></b-img>
            </template>
            <template v-else>       
              <b-img v-if="data.code != '1001'" class='courseLogo' :src='data.event_sponsor_logo'></b-img>
              <b-img v-else class="courseLogo" :src="data.event_sponsor_logo"></b-img>
            </template>
            <template v-if="tmparams.use_full_name == 'N'">
              <h3 class="homeHead">{{ data.short_name }} {{ liveOn }} - {{ title }}</h3>
            </template>
            <template v-else>
              <h3 class="homeHead">{{ data.full_name }} {{ liveOn }} - {{ title }}</h3>
            </template>
            <div class="homecourseDates">{{data.course_dates}}</div>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <b-row v-else class="title">
      <b-col class="titleLeftmobileWidth">
        <template v-if="tmparams.use_full_name == 'N'">
          <h3 class="homeHead">{{ data.short_name }} - {{ title }}</h3>
        </template>
        <template v-else>
          <h3 class="homeHead">{{ data.full_name }} - {{ title }}</h3>
        </template>
      </b-col>
      <b-col
      >
      <div v-if="data.alt_heading == 'Y'">
        <span class="AltText">
          <span v-if="data.alt_heading_text_1.length">{{ data.alt_heading_text_1.length }}</span>
          <span v-if="data.alt_heading_text_2.length">{{ data.alt_heading_text_2.length }}</span>
          <span v-if="data.alt_heading_text_3.length">{{ data.alt_heading_text_3.length }}</span>
        </span>
      </div>
      </b-col>
      <b-col class="informationMobilewidth"
      >
        <div class="sponLogo">
          <!-- <i v-b-toggle.collapse-3 class="fa-solid fa-circle-info"></i> -->
              <img class="informationImg" v-b-toggle="'collapse-1'" src="https://ocs-sport.ams3.cdn.digitaloceanspaces.com/bvt/2024/07/Information.png">
        </div>
      </b-col>
    </b-row>
    <template v-if="show_info_web == 'Y'">
      <b-collapse id="collapse-1" class="mt-2 informationCLass" visible>
        <Information
          :data="data"
          :previousData="previousData"
          :home="home"
          :title="title"
          :config="config"
          :team="team"
          :match="match"
          :code="data.code"
          :report="report"
          :live="live"
          :season="data.season"
          :takeover="takeover"
          :bbTeamEvent="data.bball_team"
          :roundsplayed="data.rounds_played"
          :showGender="showGender"
          :Stableford="Stableford"
        />
      </b-collapse>
    </template>
    <template v-else>
      <b-collapse id="collapse-1" class="mt-2 informationCLass">
        <Information
          :data="data"
          :previousData="previousData"
          :home="home"
          :title="title"
          :config="config"
          :team="team"
          :match="match"
          :code="data.code"
          :report="report"
          :live="live"
          :season="data.season"
          :takeover="takeover"
          :bbTeamEvent="data.bball_team"
          :roundsplayed="data.rounds_played"
          :showGender="showGender"
          :Stableford="Stableford"
        />
      </b-collapse>
    </template>
    
    <table>
      <thead>
        <tr v-if="home === false">
          <template v-if="tablePick === 'Draw'">
            <th v-if="data.match_play === 'Y'">
              Group
            </th>
            <th v-else>
              Match
            </th>
            <th class="Timecenter">
              Time
            </th>
            <th v-if="data.multi_course === 'Y'">
              Course
            </th>
            <th v-if="data.match_play_team === 'Y'">
              Team
            </th>
            <th>
              Tee
            </th>
            <!-- <th style="padding-left: 50px;" class="playersLeft"> -->
            <th class="playersLeft">
              Players
            </th>
          </template>
        </tr>
      </thead>
        <template v-for="(tabledata, index) in Eds">
          <tr @click.stop="rowClicked(index)" :key="index" :class="{ trTableHome: home === true}" >
            <template v-if="tablePick === 'Draw' && data.match_play === 'N'"> 
              <td>{{tabledata[0].match}}</td>
              <td style="text-align:center">{{tabledata[0].time}}</td>
              <template v-if="data.multi_course === 'Y'">
                <td class="multiCourseSpan">
                  <span :class='tabledata[0].course_colour'>
                  {{ tabledata[0].course }}
                  </span>
                </td>
              </template>
              <template v-if="data.multi_course === 'Y'">
                <td class="multiTee">{{tabledata[0].tee}}</td>
              </template>
              <template v-else>
                <td>{{tabledata[0].tee}}</td>
              </template>
              <td class="PlayerPad">
                <p v-for="(player, index2) in tabledata" :key="index2" class="noMargin">

                  <template v-if="bbTeamEvent === 'Y'">
                    <div class="DrawTeamName">
                      {{ player.name }}
                    </div>
                    <div class="pairName" v-show='toggle'>
                      <span class="namePair" v-if="player.pair_1_name.length > 0">
                        {{player.pair_1_name}}
                      </span>
                      <span class="namePair" v-if="player.pair_2_name.length > 0">
                        {{player.pair_2_name}}
                      </span>
                      <span class="namePair" v-if="player.pair_3_name.length > 0">
                        {{player.pair_3_name}}
                      </span>
                      <span class="namePair" v-if="player.pair_4_name.length > 0">
                        {{player.pair_4_name}}
                      </span>
                    </div>
                  </template>
                  <template v-else>
                    <template v-if="player.profile === 'Y'">
                      <a :href="'/player-profiles/' + player.playerno" target="_blank" class="playerLink">
                        {{ player.name}}
                        <span v-if="player.pro_ind === 'Am'">(a)</span>
                        <span class="arrowLink">
                          <a :href="'/player-profiles/' + player.playerno" target="_blank" class="linkPlayerProfile">
                            <span class="iconRight">
                              <font-awesome-icon
                                class="icon"
                                :icon="['fa', 'chevron-right']"
                              />
                            </span>
                          </a>
                        </span>
                      </a>
                    </template>
                    <template v-else>
                      {{ player.name}}
                      <span v-if="player.pro_ind === 'Am'">(a)</span>
                    </template>
                  </template>
                  <span
                    v-if="showGender === 'Y'"
                    class="multiDot-size-reportgender"
                    :class="{female : player.gender === 'F', male : player.gender === 'M'}"
                  >•</span>
                </p>
              </td>
            </template>
            <template v-if="tablePick === 'Draw' && data.match_play === 'Y'">
              <td>
                {{ tabledata[0].match }}
              </td>
              <td class="centerTime">
                {{ tabledata[0].time }}
              </td>
              <td v-if="data.match_play_team == 'Y'">
                <div>
                  <span
                    class="teamcolourPad"
                    :style="
                    'background-color:' +
                    tabledata[0].tmp_colour_1
                  ">
                    {{tabledata[0].tmp_nat_1}}
                  </span>
                </div>
                <div>
                  <span
                    class="teamcolourPad"
                    :style="
                    'background-color:' +
                    tabledata[0].tmp_colour_2
                  ">{{tabledata[0].tmp_nat_2}}</span>
                </div>
              </td>
              <td class="">
                {{ tabledata[0].tee }}
              </td>
              <td class="noPadLeft">
                <div>
                  {{ tabledata[0].name_1 }}
                </div>
                <div>
                  {{ tabledata[0].name_2 }}
                </div>
              </td>
            </template>
          </tr>
        </template>
      <!-- <tbody>
        <template v-for="(tabledata, index) in Eds">
          <tr
            @click.stop="rowClicked(index)"
            :key="index"
            v-bind:class="{
              'homeTd-size': home === true,
              drawHome: home === true && tablePick === 'Draw',
            }"
          >
            <template v-if="tablePick === 'Draw' && match === 'N' && data.bball_team === 'N' && data.team_event === 'N'">
              <td
                class="posnum drawPos"
                :class="{
                  odd: tabledata.match % 2 === 1,
                  even: tabledata.match % 2 === 0,
                }"
                v-if="tabledata.place == 1"
              >
                <span>
                  {{ tabledata.match }}
                </span>
              </td>
              <td
                :class="{
                  odd: tabledata.match % 2 === 1,
                  even: tabledata.match % 2 === 0,
                }"
                v-else
                class="noPos"
              >
                <span>.</span>
              </td>
              <td
                class="centerTime"
                :class="{
                  odd: tabledata.match % 2 === 1,
                  even: tabledata.match % 2 === 0,
                }"
                v-if="tabledata.place == 1"
              >
                {{ tabledata.time }}
              </td>
              <td
                :class="{
                  odd: tabledata.match % 2 === 1,
                  even: tabledata.match % 2 === 0,
                }"
                v-else
              ></td>
              <template v-if="data.multi_course === 'Y'">
                <td
                  :class="{
                    odd: tabledata.match % 2 === 1,
                    even: tabledata.match % 2 === 0,
                  }"
                  v-if="tabledata.place == 1"
                >
                  {{ tabledata.course }}
                </td>
                <td
                  :class="{
                    odd: tabledata.match % 2 === 1,
                    even: tabledata.match % 2 === 0,
                  }"
                  v-else
                ></td>
              </template>
              <td
                :class="{
                  odd: tabledata.match % 2 === 1,
                  even: tabledata.match % 2 === 0,
                }"
                v-if="tabledata.place == 1"
              >
                {{ tabledata.tee }}
              </td>
              <td
                :class="{
                  odd: tabledata.match % 2 === 1,
                  even: tabledata.match % 2 === 0,
                }"
                v-else
              ></td>
              <td
                class="drawName"
                :class="{
                  odd: tabledata.match % 2 === 1,
                  even: tabledata.match % 2 === 0,
                }"
              >
                <a
                  :href="'/player-profiles/' + tabledata.playerno"
                  :class="{ homePlayername: home === true }"
                >
                  {{ tabledata.name }}</a
                >
                <span v-if="tabledata.pro_ind === 'Am'">(a)</span>
                <span
                  v-if="showGender === 'Y'"
                  class="multiDot-size-reportgender"
                  :class="{female : tabledata.gender === 'F', male : tabledata.gender === 'M'}"
                  >•</span>
              </td>
            </template>
            <template v-if="tablePick === 'Draw' && data.match_play === 'N' && data.bball_team === 'Y' || data.team_event === 'Y'">
              <td
                class="posnum drawPos teamDraw"
                :class="{
                  odd: tabledata.match % 2 === 1,
                  even: tabledata.match % 2 === 0,
                }"
                v-if="tabledata.place == 1"
              >
                <span>
                  {{ tabledata.match }}
                </span>
              </td>
              <td
                :class="{
                  odd: tabledata.match % 2 === 1,
                  even: tabledata.match % 2 === 0,
                }"
                v-else
                class="noPos"
              >
                <span>.</span>
              </td>
              <td
                class="centerTime teamDraw"
                :class="{
                  odd: tabledata.match % 2 === 1,
                  even: tabledata.match % 2 === 0,
                }"
                v-if="tabledata.place == 1"
              >
                <span>
                  {{ tabledata.time }}
                </span>
              </td>
              <td
                :class="{
                  odd: tabledata.match % 2 === 1,
                  even: tabledata.match % 2 === 0,
                }"
                v-else
              ></td>
              <template v-if="data.multi_course === 'Y'">
                <td
                  :class="{
                    odd: tabledata.match % 2 === 1,
                    even: tabledata.match % 2 === 0,
                  }"
                  v-if="tabledata.place == 1"
                >
                  {{ tabledata.course }}
                </td>
                <td
                  :class="{
                    odd: tabledata.match % 2 === 1,
                    even: tabledata.match % 2 === 0,
                  }"
                  v-else
                ></td>
              </template>
              <td
                class="Tee"
                :class="{
                  odd: tabledata.match % 2 === 1,
                  even: tabledata.match % 2 === 0,
                }"
                v-if="tabledata.place == 1"
              >
                <span>
                  {{ tabledata.tee }}
                </span>
              </td>
              <td
                :class="{
                  odd: tabledata.match % 2 === 1,
                  even: tabledata.match % 2 === 0,
                }"
                v-else
              ></td>
              <td
                class="drawName"
                :class="{
                  odd: tabledata.match % 2 === 1,
                  even: tabledata.match % 2 === 0,
                }"
              >
                <div @click='toggle = !toggle' class="DrawTeamName">
                  {{ tabledata.name }}
                </div>
                <div class="pairName" v-show='toggle'>
                  <span class="namePair" v-if="tabledata.pair_1_name.length > 0">{{tabledata.pair_1_name}}</span>
                  <span class="namePair" v-if="tabledata.pair_2_name.length > 0">{{tabledata.pair_2_name}}</span>
                  <span class="namePair" v-if="tabledata.pair_3_name.length > 0">{{tabledata.pair_3_name}}</span>
                  <span class="namePair" v-if="tabledata.pair_4_name.length > 0">{{tabledata.pair_4_name}}</span>
                </div>
              </td>
            </template>
            <template v-if="tablePick === 'Draw' && data.match_play === 'Y'">
              <td>
                {{ tabledata.match }}
              </td>
              <td>
                {{ tabledata.time }}
              </td>
              <td>
                {{ tabledata.tee }}
              </td>
              <td>
                <p :class="{ homePlayername: home === true }">
                  {{ tabledata.name_1 }}
                </p>
                <p :class="{ homePlayername: home === true }">
                  {{ tabledata.name_2 }}
                </p>
              </td>
            </template>
          </tr>
        </template>
      </tbody> -->
    </table>
    <div v-if="home === true">
      <b-container>
        <b-row class="homeLeader drawLead">
          <b-col>
            <b-nav-item
              class="fullNav"
              :to="{
                name: 'reports-page',
                query: {
                  url: this.report,
                  id: season,
                  code: code,
                  title: title,
                },
              }"
            >
              <h3 class="FullLeaderboard">Full Leaderboard</h3>
            </b-nav-item>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
// import axios from "axios";
import Information from "@/components/information.vue"
import VueLodash from 'vue-lodash'
import lodash from 'lodash'
import _ from 'lodash'

export default {
  name: "Draw",
  components: {
    Information
  },
  componentss: [
    Information,
    lodash,
    VueLodash,
    _,
  ],
  props: [
    "data",
    "previousData",
    "home",
    "title",
    "report",
    "code",
    "season",
    "takeover",
    "config",
    "team",
    "match",
    "live",
    "RTCDS",
    "showGender",
    "bbTeamEvent",
    "web_sponsor",
    "show_info_web",
    "hide_score_card",
    "tm_params",
    "tmparams"
  ],
  data() {
    return {
      up: "up",
      down: "down",
      scores: [],
      clickedRow: -1,
      cardID: [],
      playerCardData: [],
      toggle: true
    };
  },
  methods: {
    range: function(start, end) {
      if (this.roundsPlayed === 1) return this.roundsPlayed;
      else
        return Array(end - start + 1)
          .fill()
          .map((_, idx) => start + idx);
    },
    rowClicked: function(index) {
      if (this.tablePick === "Score" || this.tablePick === "Live")
        this.clickedRow = index;
      else this.clickedRow = -1;
    },
  },
  computed: {
    tablePick: function(picked) {
      if (this.title.includes("Draw")) picked = "Draw";
      return picked;
    },
    roundsPlayed() {
      return parseInt(this.data.rounds_played);
    },
    Eds(reportData) {
      if (this.home === false) {
        if (this.title.includes("Draw"))
          reportData = this.data.draw.draw_entry;
          // console.log("reportData")
          // console.log(reportData)
          if (this.data.web_show_match == 'N' && this.data.web_show_tee_times == 'Y') {
            return  _.groupBy(reportData, 'time');
          } else {
            return  _.groupBy(reportData, 'match');
          }
      } else {
        if (this.title.includes("Draw"))
          reportData = this.data.draw.draw_entry.slice(0, 6);
        return  _.groupBy(reportData, 'match');
      }
    },
  },
  watch: {
    Eds(newValue, oldValue) {
      newValue.forEach((value1, key1) => {
        oldValue.forEach((value2, key2) => {
          if (value1.id === value2.id) {
            if (key1 < key2) {
              value1.posChang = "up";
            } else if (key1 > key2) {
              value1.posChang = "down";
            }
          }
        });
      });

      console.log(newValue);
    },
    immediate: true,
    deep: true,
  },
  filters: {
    lowercase: function(value) {
      if (!value) {
        return "";
      }
      return value.toLowerCase() + ".svg";
    },
  },
};
</script>


<style scoped>
/* =========================================
   GENERAL / INFORMATION
========================================= */

td.multiCourseSpan > span {
  font-size: 1rem !important;
}

::v-deep img.informationImg.not-collapsed,
::v-deep img.informationImg.collapsed {
  width: 15px;
}

::v-deep .informationCLass {
  margin-top: 0 !important;
}

::v-deep .iconRight:hover {
  color: #c99b32;
}

::v-deep tr:hover {
  background-color: #f0f4f9 !important;
  cursor: pointer;
}

.hideRepresentsHome,
.natNone,
.homeHide {
  display: none;
}

/* =========================================
   PLAYER LINKS
========================================= */

.playerLink,
.linkPlayerProfile,
.DrawTeamName {
  color: #26354b;
  font-weight: 600;
  text-decoration: none;
}

.playerLink:hover,
.linkPlayerProfile:hover {
  color: #c99b32;
  text-decoration: none;
}

td.drawName > a {
  color: #172e50;
  font-weight: 600;
}

.trTableHome > td > p > a {
  color: #175b98;
  font-weight: 600;
}

tr.drawHome > td > a {
  color: #172e50 !important;
  font-weight: 600;
}

a.homePlayername {
  color: #26354b;
}

a.homeResult {
  color: #175b98 !important;
  font-weight: 600;
}

p.homePlayername,
td.homePlayername {
  color: #26354b;
}

th.representsText,
td.representsText {
  text-align: left !important;
}

/* =========================================
   DRAW LAYOUT / PLAYER SPACING
========================================= */

.PlayerPad {
  padding-left: 50px;
}

td {
  vertical-align: middle;
}

td.Tee,
td.teamDraw {
  vertical-align: top;
}

td.Tee > span,
td.teamDraw > span {
  padding-top: 8px;
  display: inline-block;
}

.teamDraw {
  top: 0 !important;
}

.pairName {
  padding-top: 10px;
  padding-bottom: 10px;
}

span.namePair {
  display: block;
}

.drawPos {
  max-width: 100% !important;
  text-align: -webkit-center !important;
  margin-top: 0 !important;
  position: relative;
  top: 3px;
}

tr.drawHome {
  border-top: 0 !important;
}

tr.drawHome > td.drawPos {
  top: 0;
}

.arrowLink {
  float: right;
  margin-right: 30px;
}

.AltText {
  display: block;
  margin-top: 12px;
}

.noPadLeft {
  padding-left: 0;
}

p.noMargin {
  margin-bottom: 5px;
}

span.R {
  color: #bb0000;
}

span.multiDot-size-reportgender {
  font-size: 30px !important;
  line-height: 0 !important;
  position: relative;
  top: 6px;
}

.female {
  color: #e33;
}

.male {
  color: #037;
}

/* =========================================
   TEAM COLOURS
========================================= */

.teamcolourPad {
  color: #fff !important;
  padding: 3px 10px;
  text-align: center;
  border-radius: 3px;
  display: inline-block;
}

/* =========================================
   TABLE DESIGN
========================================= */

table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  background: #fff;
  color: #26354b;
  font-size: 14px;
}

thead > tr {
  color: #fff;
}

th {
  position: sticky;
  background: #09264b;
  color: #fff !important;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.45px;
  text-transform: uppercase;
  white-space: nowrap;
  padding: 14px 12px;
  border: none;
  border-bottom: 3px solid #c99b32;
  z-index: 1;
}

th:first-child,
td:first-child {
  text-align: center;
}

th:nth-child(3),
td:nth-child(3) {
  text-align: center;
}

th.playersLeft {
  padding-left: 48px;
}

td {
  font-size: 14px;
  padding: 12px;
  height: 110px;
  color: #35445a;
  border: none;
  border-bottom: 1px solid #edf0f4;
}

td > a {
  color: #172e50;
  font-weight: 600;
  text-decoration: none;
}

tr:nth-child(odd) {
  background-color: #fff;
}

tr:nth-child(even) {
  background-color: #f7f9fc;
}

.odd {
  background-color: #fff !important;
  padding-bottom: 0;
  padding-top: 0;
}

.even {
  background-color: #f7f9fc !important;
  padding-bottom: 0;
  padding-top: 0;
}

::v-deep tbody tr:hover {
  background-color: #f0f4f9 !important;
  transition: background-color 0.15s ease;
}

/* =========================================
   HOME / DRAW HEADER
========================================= */

.row.homeLeader.drawLead {
  padding-bottom: 0 !important;
}

.homeLeader {
  text-align: center !important;
  background-color: #09264b !important;
  color: #fff;
  padding: 0 !important;
  padding-bottom: 10px !important;
}

.homeHead {
  font-size: 11pt;
  padding: 20px 20px 0;
  text-align: center;
  font-weight: 500;
}

.homecourseDates {
  font-size: 11pt;
  padding-bottom: 15px;
}

.home {
  width: 300px;
  position: absolute;
  top: 30px;
  right: 30%;
}

.homeCell {
  padding: 12px;
  font-size: 10pt;
}

.homeCell > a {
  color: #172e50;
  font-weight: 600;
}

/* =========================================
   SPECIAL DRAW ROWS
========================================= */

.trTableHome {
  background-color: #f7f9fc !important;
  color: #35445a;
  border-top: 1px solid #edf0f4 !important;
}

.trTableHome > td {
  font-size: 10pt;
  padding-top: 8px;
  padding-bottom: 8px;
}

tr.homeTd-size {
  background-color: #fff !important;
  color: #35445a;
  border-top: 1px solid #edf0f4 !important;
}

tr.homeTd-size > td {
  font-size: 11pt;
  color: #35445a;
}

/* =========================================
   POSITIONS / FLAGS
========================================= */

.posCell,
.scoreCell {
  width: 2%;
}

td.posnum {
  padding: 5px;
  padding-top: 4px;
  padding-bottom: 10px;
  display: block;
  max-width: 58px;
  margin: 8px auto 0;
  font-weight: 700;
  color: #172e50;
}

td.posnum > span {
  padding: 5px;
  display: block;
  max-width: 58px;
}

.noPos > span {
  color: transparent;
  padding: 5px;
  display: block;
  max-width: 58px;
}

.flag {
  width: 30px;
  box-shadow: 0 0 1px #555;
}

.up {
  color: #a52a2a;
}

.down {
  color: #1e90ff;
}

/* =========================================
   TOURNAMENT TITLE
========================================= */

.title {
  text-align: center;
  background-color: #09264b;
  color: #fff;
  margin-left: 0;
  margin-right: 0;
}

.title > .col > h3 {
  color: #fff;
  padding: 15px 0 15px 10px;
  font-size: 13pt;
  margin: 0;
  line-height: 24px;
  text-transform: capitalize;
  background-color: #09264b;
  text-align: left;
  font-weight: 600;
}

h3.FullLeaderboard {
  font-size: 14pt;
  font-weight: 600;
  padding-top: 10px;
  padding-bottom: 4px;
}

.tLogo {
  width: 65px;
  margin-top: -5px;
  margin-right: 15px;
}

.sponLogo {
  margin-top: 15px;
  float: right;
  padding-right: 27px;
  color: #fff;
  font-size: 12pt;
}

.title > p {
  font-size: 16px !important;
  margin-bottom: 0;
}

td.catD {
  background: #09264b;
  color: #fff;
}

/* =========================================
   COURSE / SPONSOR LOGOS
========================================= */

.courseLogo {
  width: 70px;
  padding-top: 25px;
}

img.titliestLogo {
  height: 12px;
  margin-bottom: 1px;
  margin-left: 10px;
}

.titlest {
  margin-top: -2.2px;
  margin-left: 10px;
  width: 37px;
}

.sponsorHome {
  margin-top: -2.2px;
  margin-left: 10px;
  width: 37px;
}

/* =========================================
   NAVIGATION / MISC
========================================= */

.fullNav {
  padding-top: 0 !important;
  display: block !important;
}

.fullNav > .nav-link {
  padding: 0 1rem;
  color: #fff;
}

.centerTime {
  text-align: center;
}

th.PadLeft {
  padding-left: 10px;
}

th.Timecenter {
  text-align: center;
}

.table-responsive {
  margin-bottom: 0;
}

div#Draw {
  display: contents;
}

/* =========================================
   LIVE / STATUS ANIMATIONS
========================================= */

.text-down {
  background: transparent;
  text-shadow: 0 0 0 rgba(255, 82, 82, 1);
  animation: glow-red 2s infinite;
  animation-iteration-count: 6;
}

@keyframes glow-red {
  to {
    text-shadow: 0 0 10px rgba(255, 82, 82, 0.7);
  }
}

.text-up {
  background: transparent;
  text-shadow: 0 0 0 rgba(51, 217, 178, 1);
  animation: glow-green 2s infinite;
  animation-iteration-count: 6;
}

@keyframes glow-green {
  to {
    text-shadow: 0 0 10px rgba(51, 217, 178, 0.7);
  }
}

.cut {
  padding: 6px 6px 6px 8px !important;
  font-size: 19px !important;
  vertical-align: middle;
  background: #aa0003;
  color: #fff;
}

/* =========================================
   RESPONSIVE
========================================= */

@media only screen and (max-width: 1024px) {
  .home {
    width: 100% !important;
    position: inherit !important;
    top: 30px;
    right: 30%;
  }

  .home > div > div {
    max-width: 100%;
  }
}

@media only screen and (max-width: 768px) {
  .playersLeft {
    padding-left: 30px !important;
  }

  .PlayerPad {
    padding-left: 30px;
  }

  .home {
    position: inherit;
    width: 100%;
  }

  .homeLeader {
    margin-left: -40px;
  }

  .homewidthTakover {
    margin-left: -15px;
  }

  .titleLeftmobileWidth {
    width: 80%;
    max-width: 80%;
  }

  .informationMobilewidth {
    width: 20%;
    max-width: 20%;
  }

  .title > .col > h3 {
    padding: 15px 0 15px 10px;
    font-size: 11pt;
    line-height: 24px;
    text-align: left;
    font-weight: 600;
  }

  th {
    padding: 11px 8px;
    font-size: 10px;
  }

  td {
    font-size: 12px;
  }
}

@media only screen and (max-width: 480px) {
  .tableMob {
    width: 275%;
  }

  .home {
    position: inherit;
    width: 100%;
  }

  ::v-deep tr > :nth-child(2) {
    font-size: 10pt;
  }

  ::v-deep th {
    font-size: 10pt;
    padding: 10px 7px;
  }

  ::v-deep td {
    font-size: 10pt;
    padding: 10px 8px;
  }

  ::v-deep .dropdown {
    width: 100%;
    padding-right: 12px;
  }

  ::v-deep .HideMovResult {
    display: none;
  }
}
</style>

